<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>{{ config?.headerTitle ? (config.headerTitle | translate) : '' }}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  @if (config) {
  <div class="result-container" [class.error]="config.type === 'error'" [class.warning]="config.type === 'warning'">
    <ion-img [src]="animationSrc"></ion-img>

    <h1 class="result-title">{{ displayTitle }}</h1>

    @if (displaySubtitle) {
    <p class="result-subtitle">{{ displaySubtitle }}</p>
    } @if (config.details?.length) {
    <ion-card>
      <ion-card-content>
        @for (detail of config.details; track detail.label) {
        <ion-item lines="none">
          @if (detail.icon) {
          <ion-icon slot="start" [src]="detail.icon"></ion-icon>
          }
          <ion-label>
            <p>{{ detail.label | translate }}</p>
            <h3>{{ detail.value }}</h3>
          </ion-label>
        </ion-item>
        }
      </ion-card-content>
    </ion-card>
    }

    <div class="actions">
      @if (config.secondaryAction) {
      <ion-button expand="block" fill="outline" (click)="secondaryAction()">
        {{ config.secondaryAction.label | translate }}
      </ion-button>
      }

      <ion-button expand="block" (click)="primaryAction()">
        {{ config.primaryAction?.label || translation.Common.Done | translate }}
      </ion-button>
    </div>
  </div>
  }
</ion-content>
